import React from 'react';
import {useFormContext} from 'react-hook-form';

const FormRadio = ({name, label, value, validate, disabled = false, errorMessage}) => {
  const {register, formState: {errors}} = useFormContext();

  return (
    <div className="form-radio">
      <input
        type="radio"
        id={`${name}-${value}`}
        value={value}
        className="form-radio-input"
        disabled={disabled}
        {...register(name, validate)}
      />
      <label className="form-radio-label ml-1" htmlFor={`${name}-${value}`}>
        {label}
      </label>

      {errors[name] && (
        <div className="invalid-feedback">{errorMessage || errors[name]?.message}</div>
      )}
    </div>
  );
};

export default FormRadio;
